<template lang="pug">
  div
    .inline-filter(@click="open")
      .inline-filter__label {{ name }}:
      .inline-filter__value {{ text }}
    MobileModal(
      ref="modal"
      :name="name"
      :hideFooter="!changed"
      @cancel="cancel"
      @apply="apply"
    )
      slot(name="filter")
</template>

<script>
import { isEqual } from 'lodash';
import MobileModal from './MobileModal.vue';

export default {
  name: 'MobileFilter',
  props: {
    name: String,
    text: String,
    initialValue: String,
  },
  components: {
    MobileModal,
  },
  computed: {
    changed() {
      return !isEqual(this.initialValue, this.$attrs.value);
    },
  },
  methods: {
    open() {
      this.$refs.modal.open();
    },
    cancel() {
      this.$emit('input', this.initialValue);
    },
    apply() {
      this.$emit('change', this.$attrs.value);
    },
  },
};
</script>
